import { LensMarket } from '~/types'
import { setAsSuppliedByFaucet } from './localStorage'

export const requestFaucetTokens = async (
  address: string,
  ip: string,
  networkId: number,
  markets: LensMarket[],
  rpcUrl: string,
  captchaToken?: string
) => {
  const response = await fetch('/api/faucet', {
    method: 'POST',
    body: JSON.stringify({
      address,
      networkId,
      ip,
      markets,
      rpcUrl,
      captchaToken,
    }),
  })

  const data = await response.json()

  if (response.status !== 200) {
    throw new Error(data?.message)
  }

  if (data) {
    setAsSuppliedByFaucet(data)
  }
}
